import { baseURL } from "../../util/Constant";
import { getImageFile,getImageStatusFile, loading } from "../redux/imageSlice";

//Get Image FIle
export const getImageFileFetch = (id) => (dispatch) => {
  dispatch(loading(false));
  fetch(`${baseURL}/image/rip/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    }
  })
    .then((res) => res.json())
    .then((data) => {
      
      dispatch(getImageFile(data.image));
      dispatch(loading(true));
    })
    .catch((error) => {
      console.error('Ошибка при загрузке изображения:', error);
      dispatch(loading(false));
    });
};

//Get Image FIle
export const getImageFileUrlFetch = (url) => (dispatch) => {
  fetch(`${baseURL}/image/put`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ url }),
  })
    .then((res) => res.blob())
    .then((data) => {
       const imageUrl = URL.createObjectURL(data);
       dispatch(getImageFile(imageUrl))
    })
    .catch((error) => {
      console.log(error);
    });
};


//Get Image FIle
export const getImageStatusFileFetch = (id) => (dispatch) => {
  dispatch(loading(false));
  fetch(`${baseURL}/image/status/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    }
  })
    .then((res) => res.json())
    .then((data) => {
      dispatch(getImageStatusFile(data.image));
      dispatch(loading(true));
    })
    .catch((error) => {
      console.error('Ошибка при загрузке изображения:', error);
      dispatch(loading(false));
    });
};